import { ThemeMode } from '../models/user.model';

export const MOBILE_SCREEN_SIZE = 925;
export const APP_NAME = 'Flex';
export const DEFAULT_APP_ICON = 'goal';
export const BLANK_ENVIRONMENT_COLOUR = '#bbd';
export const DEFAULT_THEME: ThemeMode = 'light';

export const DEFAULT_DEV_ENVIRONMENT = {
    name: 'DEV',
    cssColour: '#bdffc6'
};

export const DEFAULT_PRODUCTION_ENVIRONMENT = {
    name: 'PRODUCTION',
    cssColour: '#b1c9ff'
};

export const DEFAULT_GROUP = {
    id: '0',
    name: 'Default',
    cssColour: ''
};
